import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
  isCheckout?: boolean;
  onClick?: () => void;
}
export function CTAButton({
  text = 'QUIERO ACCEDER A KINESIOTAPING CLÍNICO PRO AHORA',
  className = '',
  href,
  isCheckout = false,
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (isCheckout && typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart');
    }
    if (onClick) onClick();
  };
  return <motion.a href={href || (isCheckout ? 'https://vitalyforms.com/products/kinesiotaping-clinical-pro' : '#pricing')} target={isCheckout ? '_blank' : undefined} rel={isCheckout ? 'noopener noreferrer' : undefined} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-block w-full md:w-auto text-center
        bg-gradient-to-r from-gold-600 via-gold-500 to-gold-600
        text-navy-900 font-bold text-lg md:text-xl
        py-4 px-8 rounded-sm shadow-[0_0_20px_rgba(201,168,76,0.3)]
        hover:shadow-[0_0_30px_rgba(201,168,76,0.5)]
        transition-shadow duration-300
        ${className}
      `} data-id="element-273">
      {text}
    </motion.a>;
}